import { find, values } from 'lodash-es'

import { SORTING_ORDERS_MAP } from '../constants'

const getTableSortingOrder = antTableSortingOrder =>
  antTableSortingOrder &&
  find(values(SORTING_ORDERS_MAP), i => i.antd === antTableSortingOrder).api

export default getTableSortingOrder
